module.exports = __webpack_public_path__ + "img/image_17.58757afa.png";